import React, { useEffect, useRef, useState, useContext } from "react";
import Button from "shared/Button";
import GroceryContext from "../GroceryContext";
import { colors } from "styles/colors";
import { FirstInputContainer, FirstInputWrapper, FirstInput, FirstButtonsWrap } from "./styled";

const CustomIngredientItemInput = ({ customEdit }) => {
  const { closeCustomIngredientInput, addCustomIngredientItem, updateCustomIngredientItem } =
    useContext(GroceryContext);
  const [customItem, setCustomItem] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (customEdit) {
      setCustomItem(customEdit.name);
    }
    inputRef.current.focus();
  }, [customEdit]);

  const saveItem = !customEdit ? addCustomIngredientItem : updateCustomIngredientItem;

  return (
    <FirstInputContainer>
      <FirstInputWrapper>
        <FirstInput
          ref={inputRef}
          value={customItem}
          placeholder="Add new ingredient"
          onKeyPress={(e) => {
            if (e.charCode === 13) {
              saveItem(customItem, customEdit);
            }
          }}
          onChange={(e) => {
            setCustomItem(e.target.value.substring(0, 80));
          }}
        />
      </FirstInputWrapper>

      <FirstButtonsWrap>
        <Button
          color={colors.WHITE}
          textColor={colors.GREY_DARK}
          stylType="outline"
          text="Cancel"
          onClick={() => closeCustomIngredientInput()}
        />
        <Button
          color={colors.RED}
          textColor={colors.WHITE}
          stylType="outline"
          text={!customEdit ? "Add" : "Save"}
          iconRight={!customEdit ? "plus" : "check"}
          onClick={() => saveItem(customItem, customEdit)}
        />
      </FirstButtonsWrap>
    </FirstInputContainer>
  );
};

export default CustomIngredientItemInput;
